//
//  Modal will be instantiated with empty values. To pass in values, whoever call this component needs to pass in a modalObject and name it's prop 'model'
//          modalObject = {
//              NewUnit: Props.model.NewUnit,
//              PreviousUnit: Props.model.PreviousUnit,
//              ShowModal: Props.model.ShowModal,
//              SpecField: Props.model.SpecField,
//              SpecValue: Props.model.SpecValue
//          }
//

class ModalSwitchSpecUnitsForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleButtonClick.bind(this);
        this.state = ModalSwitchSpecUnitsForm.modelToState();
    }

    static modelToState() {
        return {
            NewUnit: "",
            PreviousUnit: "",
            ShowModal: false,
            SpecField: "",
            SpecValue: "",
        };
    }

    componentWillReceiveProps(Props) {
        if (Props.model != null) {
            this.setState({
                NewUnit: Props.model.NewUnit,
                PreviousUnit: Props.model.PreviousUnit,
                ShowModal: Props.model.ShowModal,
                SpecField: Props.model.SpecField,
                SpecValue: Props.model.SpecValue
            });
        }
        else {
            this.setState({
                NewUnit: "",
                PreviousUnit: "",
                ShowModal: false,
                SpecField: "",
                SpecValue: ""
            });
        }
    }

    handleButtonClick(field, value) {
        var state = this.state;

        state[field] = value

        this.setState(state)
    }

    ChangeSpecUnits() {
        var parentModel = this.props.parentModel;

        var objectToSend = {
            FormInputs: parentModel.FormInputs,
            Category: parentModel.Category,
            SystemOfMeasurement: this.state.NewUnit,
            QueryString: parentModel.QueryString,
        }

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);
            parentModel.FormInputs = response.oSpecsViewModel.FormInputs;
            parentModel.SystemOfMeasurement = response.oSpecsViewModel.SystemOfMeasurement

            parentModel.FormInputs[this.state.SpecField] = { Value: this.state.SpecValue, Page: 0 };    //the specfield we changed needs to stay the same.

            //hide modal and don't show anymore
            parentModel.ShowUnitSwitchModal = false;
            parentModel.firstSpecWithUnit = null;
            parentModel.modalObject = null;

            this.props.handleFormUpdate(parentModel);
            this.props.handleMasterViewUpdate(parentModel);
            this.props.SaveSpecsToXML(parentModel);

            //this calls the javascript close in the SinglePageUI.js
            CloseModal();
        }.bind(this);

        xhr.open("POST", '/listinginput/specs/changesystemofmeasurement' + parentModel.QueryString, false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    CloseModal() {
        var parentModel = this.props.parentModel;
        parentModel.modalObject = null;
        parentModel.CurrentPage = 0;
        parentModel.ShowUnitSwitchModal = false;
        this.props.handleFormUpdate(parentModel);
        this.props.handleMasterViewUpdate(parentModel);
        this.props.SaveSpecsToXML(parentModel);

        //this calls the javascript close in the SinglePageUI.js
        CloseModal();
    }

    render() {

        var style = {};
        if (this.state.ShowModal)
            style.display = 'block';
        else
            style.display = 'none';

        var newUnit = "";
        var previousUnit = "";

        if (this.state.NewUnit == "Imperial") {
            newUnit = this.props.parentModel.Translations["SwitchToImperial"];
            previousUnit = this.props.parentModel.Translations["NoKeepMetric"];
        }
        else {
            newUnit = this.props.parentModel.Translations["SwitchToMetric"];
            previousUnit = this.props.parentModel.Translations["NoKeepImperial"];
        }

        return (
            <div className="modal" id="unit-switch-modal-Specs" style={style}>
                <div className="modal-content">
                    <div className="modal-head">
                        <h2>{this.props.parentModel.Translations["UnitOfMeasure"]}</h2>
                        <span className="close" onClick={(e) => { this.CloseModal(); }}><i className="fa fa-times" aria-hidden="true"></i></span>
                    </div>
                    <div className="modal-main">
                        {newUnit}?
                    </div>
                    <div className="modal-buttons cf">
                        <button role="link" className="save-modal PrimaryBGC siteFontColor" onClick={(e) => { this.ChangeSpecUnits(); }}>{newUnit}?</button>
                        <button role="link" className="cancel-modal" onClick={(e) => { this.CloseModal(); }}>{previousUnit}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalSwitchSpecUnitsForm;
global.ModalSwitchSpecUnitsForm = ModalSwitchSpecUnitsForm;